
  import { Component, Prop, Vue } from "vue-property-decorator";
  import Tooltip from "@/components/common/Tooltip.vue";
  import Variants from "@/entities/TooltipVariants";


  @Component({
    components: {
      Tooltip,
    },
  })
  export default class EmployeeRemovedFromCompanyTooltip extends Vue {
    @Prop({type: Boolean, required: true}) readonly disabled!: boolean;

    Variants = Variants;
  }
